import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  color: hsla(var(--fgColorString) / 0.66);

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }

  &[data-layout='default'] ${SectionWrapperStyles.Inner} {
    max-width: 1040px;
  }
`;
const ImageLinkWrapper = styled.div `
  width: 100%;
`;
const ImageWrapper = styled.figure `
  width: 100%;
  grid-column: 1 / span 4;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 8;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 2 / span 10;
  }
`;
const ImageContainer = styled.div `
  border-radius: var(--borderRadius);
  overflow: hidden;
`;
const Image = styled.img `
  display: block;
  width: 100%;
  border-radius: var(--borderRadius);
`;
const Caption = styled.figcaption `
  font-weight: 400;
  color: currentColor;
  font-size: ${fluid(14, 15)};
  line-height: ${fluid(21, 23)};
  text-align: center;
  margin: 18px 0 0;
`;
const ImageBlockStyles = {
    Container,
    Caption,
    Image,
    ImageLinkWrapper,
    ImageWrapper,
    ImageContainer,
};
export default ImageBlockStyles;
